export enum FILTER_NOTIFICATIONS {
  MOST_RECENT = 'mostRecent',
  UNREAD = 'unread',
  OLDER = 'older',
}
